import { alpha } from '@mui/material';
export const useFamilyMemberCardStyles = () => {
    return {
        container: {
            backgroundColor: (theme) => theme.palette.grey[300],
            borderRadius: (theme) => theme.spacing(3),
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
            padding: (theme) => theme.spacing(2),
            position: 'relative',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            transition: 'all 0.2s ease-in-out'
        },
        optionsButton: {
            position: 'absolute',
            top: (theme) => theme.spacing(1),
            right: (theme) => theme.spacing(1)
        },
        optionsIcon: {
            border: 'none'
        },
        avatarContainer: {
            marginBottom: (theme) => theme.spacing(1.5)
        },
        avatar: {
            width: 64,
            height: 64,
            borderRadius: '500px',
            backgroundColor: (theme) => theme.palette.grey[100],
            color: (theme) => theme.palette.primary.main,
            '& img': {
                objectFit: 'cover'
            }
        },
        memberInfo: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1
        },
        memberName: {
            fontSize: '16px',
            fontWeight: 600,
            color: (theme) => theme.palette.grey[900],
            marginBottom: (theme) => theme.spacing(0.5)
        },
        relationship: {
            fontSize: '14px',
            color: (theme) => theme.palette.grey[600],
            marginBottom: (theme) => theme.spacing(0.5)
        },
        age: {
            fontSize: '12px',
            color: (theme) => theme.palette.grey[500]
        }
    };
};
